import DocumentUIService from '@/modules/core/app/services/DocumentUIService';
import Logger from '@/modules/core/app/helpers/Logger';
import SnackbarService from '@/modules/core/ui/services/SnackbarService';
import { ExportViewerServiceFactory } from '@/modules/export/services/ExportViewerServiceFactory';
import Lang from '@/modules/core/app/services/Lang';

export const DownloadToPdfMixin = {
  data() {
    return {
      snackbar: null,
      service: null,
      increment: 0,
      percentValue: 0,
      randomThreshold: Math.random() * 50 + 45
    };
  },
  methods: {
    onPrint() {
      window.print();
    },
    async onDownload() {
      try {
        const message = this.service.getSnackBarTitle();
        const html = `
          <div class="export-progress-download">
            <div>${message}</div>
            <div class="is-full-width m-t-5">
                <progress id="progress-download" class="progress is-success is-small is-full-width" value="0" max="100"></progress>
            </div>
          </div>
        `;

        if (this.snackbar) {
          this.snackbar.close();
        }
        this.snackbar = SnackbarService.show(html, {
          position: 'is-top-right',
          type: 'is-primary',
          indefinite: true,
          actionText: Lang.t('core.hide')
        });
        this.$nextTick(() => {
          this.activateLoader();
          this.updateLoader();
        });
        const response = await this.service.download();
        const filename = this.service.getFilename();
        return DocumentUIService.downloadFile(response, filename);
      } catch (e) {
        Logger.error(e.message);
      } finally {
        this.snackbar.close();
        this.deactivateLoader();
      }
    },
    updateLoader() {
      this.updateTimeout = setTimeout(() => {
        const $element = document.querySelector('#progress-download');
        $element.value = this.percentValue;
        this.timeout && this.updateLoader();
      }, 1);
    },
    activateLoader() {
      this.timeout = setTimeout(
        () => {
          if (this.percentValue >= 95) {
            return;
          }
          this.increment += Math.random();
          this.percentValue =
            this.percentValue > this.randomThreshold
              ? this.randomThreshold + Math.log(this.increment)
              : this.increment;
          this.timeout && this.activateLoader();
        },
        this.percentValue > this.randomThreshold ? 1 : 50
      );
    },
    deactivateLoader() {
      clearTimeout(this.timeout);
      clearTimeout(this.updateTimeout);
      this.increment = 0;
      this.percentValue = 0;
    },
    dismiss() {
      window.close();
    }
  },
  created() {
    this.service = ExportViewerServiceFactory.build(this.type, this.resourceId, this.params);
  }
};
